// import RequestInbox from './Inbox'

export default {
  priority: 3,
  permissions: ['RequestsMenu/Box/ReceivedMenu'],
  component: load(() => import(/* webpackChunkName: "RequestInbox" */ './Inbox')),
  // component: RequestInbox,
  name: app.translate('routes.home.requests.Inbox'),
  icon: 'inbox-arrow-down',
  drawer: true,
};


